module.exports = __webpack_public_path__ + "img/cadreLarge.42c20a9a.png";